import { toast } from 'react-toastify';
import React, { FC, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Upload, Button, Image } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import { URL as COMMON_URL } from '../../../redux/common/url';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Tag } from 'antd';

const ForceBooking: FC = () => {
    const { id, status } = useParams();
    const [bookingData, setBookingData] = useState<any>({});
    const [bookingId, setBookingId] = useState<number | undefined>();
    const [acceptedTime, setAcceptedTime] = useState<string>("");
    const [completeTime, setCompleteTime] = useState<string>("");
    const [fillingImage, setFillingImage] = useState<File | null>(null);
    const [fillingVideo, setFillingVideo] = useState<File | null>(null);
    const [destinationImage, setDestinationImage] = useState<File | null>(null);
    const [destinationVideo, setDestinationVideo] = useState<File | null>(null);
    const [previewImage, setPreviewImage] = useState<{ [key: string]: string }>({});
    const [fileStatus, setFileStatus] = useState<{ [key: string]: string }>({});
    const [watermarkText, setWatermarkText] = useState("");

    const formatDateTime = (input: string): string | null => {
        if (!input) return null;
        return moment(input).format('YYYY-MM-DD hh:mm A');
    };

    // ==================== Watermark Generator (ONLY for Filling Image) ====================
// ==================== Watermark Generator ====================
const generateWatermark = async (imageFile: File) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    const img = new window.Image();
    img.src = URL.createObjectURL(imageFile);

    await new Promise((resolve) => {
        img.onload = resolve;
    });

    // Canvas Size
    canvas.width = img.width;
    canvas.height = img.height;

    // Draw Original Image
    ctx.drawImage(img, 0, 0);

    // =========================
    // WATERMARK DATA
    // =========================
    const lines = watermarkText.split('\n');

    const name = lines[0] || '';
    const date = lines[1] || '';
    const lat = lines[2] || '';
    const long = lines[3] || '';

    // =========================
    // TEXT STYLE
    // =========================
    ctx.fillStyle = '#F71512'; // Pure Red
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';

    // REMOVE SHADOW
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;

    // =========================
    // RESPONSIVE FONT SIZE
    // =========================
   const topFontSize = Math.max(canvas.width * 0.027, 19);
const bottomFontSize = Math.max(canvas.width * 0.027, 19);

    // Left Margin
    const marginLeft = 20;

    // =========================
    // TOP NAME
    // =========================
    ctx.font = `bold ${topFontSize}px Arial`;

    ctx.fillText(
        `Name: ${name}`,
        marginLeft,
        24
    );

    // =========================
    // BOTTOM TEXT
    // =========================
    ctx.font = `bold ${bottomFontSize}px Arial`;

    const lineHeight = bottomFontSize + 15;

    // Bottom Position
    const startY = canvas.height - (lineHeight * 3) - 2;

    const acceptedFormatted = moment(acceptedTime).format('ddd MMM DD HH:mm:ss [GMT]Z YYYY');

    ctx.fillText(
        `Date: ${acceptedFormatted}`,
        marginLeft,
        startY
    );

    ctx.fillText(
        `Lat: ${lat}`,
        marginLeft,
        startY + lineHeight
    );

    ctx.fillText(
        `Long: ${long}`,
        marginLeft,
        startY + (lineHeight * 2)
    );

    // =========================
    // EXPORT WATERMARK IMAGE
    // =========================
    return new Promise<File>((resolve) => {
        canvas.toBlob(
            (blob) => {
                if (blob) {
                    resolve(
                        new File(
                            [blob],
                            imageFile.name,
                            {
                                type: 'image/jpeg',
                            }
                        )
                    );
                }
            },
            'image/jpeg',
            1
        );
    });
};

    const fetchBookingDetails = async () => {
        if (!bookingId) {
            toast.error("Please enter a booking ID");
            return;
        }

        try {
            const token = JSON.parse(localStorage.getItem('kt-auth-react-v')!);
            const config = {
                headers: {
                    Authorization: 'Bearer ' + token.api_token,
                },
            };

            const res = await axios.post(`${COMMON_URL.API_BASE_URL}${COMMON_URL.bookingDetails}`, { id: bookingId }, config);
            const data = res?.data?.data;

            if (data) {
                setBookingData(data);
                setAcceptedTime(data?.accepted_time || "--");
                setCompleteTime(data?.complete_time || "--");

                const driverName = data?.driver?.name || "";
                const formattedDate = moment(data?.accepted_time).format( 'ddd MMM DD HH:mm:ss [GMT]Z YYYY');
                const lat = data?.source_hydrant_center?.latitude || 0;
                const lon = data?.source_hydrant_center?.longitude || 0;

                // Only set watermark if we have valid data (no dummy figures)
                if (driverName || formattedDate || lat !== 0 || lon !== 0) {
                    const text = `${driverName}\n${formattedDate}\n ${lat}\n${lon}`;
                    setWatermarkText(text);
                } else {
                    setWatermarkText("");
                }

                // Set media states
                setPreviewImage({
                    fillingImage: data?.filling_image ? `${COMMON_URL.API_BASE_URL}${data.filling_image}` : '',
                    destinationImage: data?.destination_image ? `${COMMON_URL.API_BASE_URL}${data.destination_image}` : '',
                    fillingVideo: data?.filling_video ? `${COMMON_URL.API_BASE_URL}${data.filling_video}` : '',
                    destinationVideo: data?.destination_video ? `${COMMON_URL.API_BASE_URL}${data.destination_video}` : '',
                });
                setFileStatus({
                    fillingImage: data?.filling_image ? `Uploaded: ${data.filling_image.split('/').pop()}` : '',
                    destinationImage: data?.destination_image ? `Uploaded: ${data.destination_image.split('/').pop()}` : '',
                    fillingVideo: data?.filling_video ? `Uploaded: ${data.filling_video.split('/').pop()}` : '',
                    destinationVideo: data?.destination_video ? `Uploaded: ${data.destination_video.split('/').pop()}` : '',
                });
            } else {
                toast.error("No booking found with this ID");
                setBookingData({});
                setAcceptedTime("--");
                setCompleteTime("--");
                setPreviewImage({});
                setFileStatus({});
                setWatermarkText("");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Error fetching booking details");
            setBookingData({});
            setAcceptedTime("--");
            setCompleteTime("--");
            setPreviewImage({});
            setFileStatus({});
            setWatermarkText("");
        }
    };

    const handleImagePreview = (file: File) => {
        const url = URL.createObjectURL(file);
        setPreviewImage((prev) => ({ ...prev, fillingImage: url }));
    };

    const uploadProps = (setFile: (file: File | null) => void, isImage: boolean, field: string) => ({
        beforeUpload: (file: File) => {
            const isValidType = isImage
                ? file.type.startsWith('image/')
                : file.type.startsWith('video/');

            if (!isValidType) {
                toast.error(`Please upload a valid ${isImage ? 'image' : 'video'} file`);
                setFileStatus((prev) => ({ ...prev, [field]: 'Failed' }));
                return false;
            }

            // ONLY FILLING IMAGE gets the watermark
            if (isImage && field === 'fillingImage' && watermarkText) {
                generateWatermark(file).then((watermarkedFile) => {
                    setFile(watermarkedFile);
                    handleImagePreview(watermarkedFile);
                });
            } else {
                setFile(file);
                handleImagePreview(file);
            }

            setFileStatus((prev) => ({ ...prev, [field]: `Uploaded: ${file.name}` }));
            return false;
        },
        fileList: [],
    });

    const handleBooking = async () => {
        if (!bookingId) {
            toast.error("Please enter a booking ID");
            return;
        }

        try {
            const token = JSON.parse(localStorage.getItem('kt-auth-react-v')!);
            const config = {
                headers: {
                    Authorization: 'Bearer ' + token.api_token,
                    'Content-Type': 'multipart/form-data',
                },
            };

            const formData = new FormData();
            formData.append('booking_id', bookingId.toString());
            formData.append('accepted_time', formatDateTime(acceptedTime) || '');
            formData.append('complete_time', formatDateTime(completeTime) || '');
            if (fillingImage) formData.append('filling_image', fillingImage);
            if (fillingVideo) formData.append('filling_video', fillingVideo);
            if (destinationImage) formData.append('destination_image', destinationImage);
            if (destinationVideo) formData.append('destination_video', destinationVideo);

            const res = await axios.post(`${COMMON_URL.API_BASE_URL}${COMMON_URL.completeBooking}`, formData, config);

            if (res?.data?.data) {
                toast.success(res?.data?.message);
                setBookingId(undefined);
                setBookingData({});
                setAcceptedTime("--");
                setCompleteTime("--");
                setFillingImage(null);
                setFillingVideo(null);
                setDestinationImage(null);
                setDestinationVideo(null);
                setPreviewImage({});
                setFileStatus({});
                setWatermarkText("");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Error completing booking");
        }
    };

    const handleVideoPreview = (url: string) => {
        const newWindow = window.open('', '_blank');
        newWindow?.document.write(`
            <video controls style="width: 100%; max-height: 100vh;">
                <source src="${url}" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        `);
    };

    return (
        <div className="container my-5">
            <div className="mb-4">
                <h2 className="fw-bold">Force Complete</h2>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/" className="text-decoration-none text-secondary">Home</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">Force Complete</li>
                    </ol>
                </nav>
            </div>

            <div className="card border-0 shadow-sm p-4 mb-4">
                <div className="row g-3 align-items-end">
                    <div className="col-md-6">
                        <label className="form-label fw-semibold">Booking ID</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter booking ID"
                            value={bookingId || ""}
                            onChange={(e) => setBookingId(e.target.value ? parseInt(e.target.value) : undefined)}
                        />
                    </div>
                    <div className="col-md-3">
                        <button onClick={fetchBookingDetails} className="btn btn-success w-100">
                            View Booking
                        </button>
                    </div>
                </div>
            </div>

            {bookingData?.id && (
                <div className="row g-4">
                    {/* Booking Details */}
                    <div className="col-md-6">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body">
                                <h5 className="mb-4">Booking Details</h5>
                                <p><strong>Booking date:</strong> {bookingData?.date || "--"}</p>
                                <p><strong>Trip ID / Trip Auto ID:</strong> {bookingData?.id || "--"}</p>
                                <p><strong>Customer Name:</strong> {bookingData?.user?.name || "--"}</p>
                                <p><strong>Mobile:</strong> {bookingData?.user?.mobile || "--"}</p>
                                <p><strong>Source Address:</strong> {bookingData?.source_hydrant_center?.address || "--"}</p>
                                <p><strong>Destination Address:</strong> {bookingData?.destination?.address || "--"}</p>
                                <p><strong>Total Distance:</strong> {bookingData?.total_distance / 2 || "--"}</p>
                                <p><strong>Status:</strong>
                                    <Tag className="ms-3" color={bookingData?.status === "Cancel" ? "red" : bookingData?.status === "Completed" ? "green" : "grey"}>
                                        {bookingData?.status}
                                    </Tag>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Trip Information */}
                    <div className="col-md-6">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body">
                                <h5 className="mb-4">Trip Information</h5>
                                <p><strong>Trip Accepted By:</strong> {bookingData?.driver?.name || "--"}</p>
                                <div className="mb-3">
                                    <label className="form-label">Trip Accepted At</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        value={acceptedTime}
                                        onChange={(e) => setAcceptedTime(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Trip End</label>
                                    <input
                                        type="datetime-local"
                                        className="form-control"
                                        value={completeTime}
                                        onChange={(e) => setCompleteTime(e.target.value)}
                                    />
                                </div>
                                <p><strong>Trip Duration:</strong> {bookingData?.trip_duration || "--"}</p>
                                <p><strong>Vehicle:</strong> {bookingData?.vehicle?.registration_number || "--"}</p>
                            </div>
                        </div>
                    </div>

                    {/* Media Uploads */}
                    <div className="col-12">
                        <div className="card border-0 shadow-sm">
                            <div className="card-body">
                                <h5 className="mb-4">Media Uploads</h5>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold me-2">Filling Image</label>
                                        <Upload {...uploadProps(setFillingImage, true, 'fillingImage')}>
                                            <Button icon={<UploadOutlined />}>Upload Filling Image</Button>
                                        </Upload>
                                        {fileStatus.fillingImage && (
                                            <p className="mt-2 text-muted">{fileStatus.fillingImage}</p>
                                        )}
                                        {previewImage.fillingImage && (
                                            <Image
                                                src={previewImage.fillingImage}
                                                style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                                                preview
                                            />
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold me-2">Destination Image</label>
                                        <Upload {...uploadProps(setDestinationImage, true, 'destinationImage')}>
                                            <Button icon={<UploadOutlined />}>Upload Destination Image</Button>
                                        </Upload>
                                        {fileStatus.destinationImage && (
                                            <p className="mt-2 text-muted">{fileStatus.destinationImage}</p>
                                        )}
                                        {previewImage.destinationImage && (
                                            <Image
                                                src={previewImage.destinationImage}
                                                style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                                                preview
                                            />
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold me-2">Filling Video</label>
                                        <Upload {...uploadProps(setFillingVideo, false, 'fillingVideo')}>
                                            <Button icon={<UploadOutlined />}>Upload Filling Video</Button>
                                        </Upload>
                                        {fileStatus.fillingVideo && (
                                            <p className="mt-2 text-muted">
                                                {fileStatus.fillingVideo}
                                                {previewImage.fillingVideo && (
                                                    <Button
                                                        type="link"
                                                        onClick={() => handleVideoPreview(previewImage.fillingVideo)}
                                                        style={{ padding: 0, marginLeft: '10px' }}
                                                    >
                                                        Preview
                                                    </Button>
                                                )}
                                            </p>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fw-semibold me-2">Destination Video</label>
                                        <Upload {...uploadProps(setDestinationVideo, false, 'destinationVideo')}>
                                            <Button icon={<UploadOutlined />}>Upload Destination Video</Button>
                                        </Upload>
                                        {fileStatus.destinationVideo && (
                                            <p className="mt-2 text-muted">
                                                {fileStatus.destinationVideo}
                                                {previewImage.destinationVideo && (
                                                    <Button
                                                        type="link"
                                                        onClick={() => handleVideoPreview(previewImage.destinationVideo)}
                                                        style={{ padding: 0, marginLeft: '10px' }}
                                                    >
                                                        Preview
                                                    </Button>
                                                )}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {bookingData?.id && (
                <div className="mt-4">
                    <button
                        onClick={handleBooking}
                        className="btn btn-primary px-4"
                    >
                        Submit
                    </button>
                </div>
            )}
        </div>
    );
};

export default ForceBooking;